import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"box"},[(!_vm.errorMessage)?_c(VProgressCircular,{attrs:{"size":75,"color":"neutralgray","indeterminate":""}}):_vm._e(),(_vm.errorMessage)?_c('h1',{staticClass:"error--text"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }